import { Label } from "@/components/ui/label";
import { FC, HTMLAttributes } from "react";

type CompanyMetaFieldProps = HTMLAttributes<HTMLDivElement> & {
  label: string;
};

const CompanyMetaField: FC<CompanyMetaFieldProps> = ({ label, ...props }) => {
  return (
    <div {...props}>
      <Label className="font-bold">{label}</Label>
      <div className="text-sm">{props.children ? props.children : <>-</>}</div>
    </div>
  );
};

export default CompanyMetaField;
